<template>
  <div class="cursor-pointer w-full" @click="navigateToSearchDocument()" data-vs-button="toDocumentSearch">
    <div class="p-4" :class="{'flex flex-col': !dashboard, 'flex': dashboard}">
      <div class="mx-auto py-3">
        <selectedFile />
      </div>
      <div class="text-zt-primary-200 text-xl flex" :class="{'pt-4 justify-center': !dashboard, 'justify-end align-center': dashboard}">
        <p>{{ $t('message.dashboard.searchDocuments') }}</p>
        <zt-icon name="angle-right" />
      </div>
    </div>
  </div>
</template>

<script>
import selectedFile from '@/components/commons/Illustrations/graphicSVG/selectedInvoiceSVG'

export default {
  name: "SearchDocuments",
  components: {
    selectedFile
  },
  props:{
    dashboard:Boolean
  },
  methods: {
    navigateToSearchDocument() {
      this.$router.push('/documents/search');
    },
  },
};
</script>

<style lang="scss" scoped></style>
